import { createFileRoute } from "@tanstack/react-router";

import { ResearchRunPage } from "../../../workspaces/training/pages/ResearchRunPage";

type ResearchTab = "attempts" | "hypotheses" | "learnings";

interface ResearchRunSearch {
  readonly tab?: ResearchTab;
  readonly run?: string;
  readonly metric?: string;
}

const TABS: readonly ResearchTab[] = ["attempts", "hypotheses", "learnings"];

export const Route = createFileRoute("/_console/p/$org/$project/training/research/$sessionName")({
  validateSearch: (search: Record<string, unknown>): ResearchRunSearch => ({
    tab:
      typeof search.tab === "string" && TABS.includes(search.tab as ResearchTab)
        ? (search.tab as ResearchTab)
        : undefined,
    run: typeof search.run === "string" ? search.run : undefined,
    metric: typeof search.metric === "string" ? search.metric : undefined,
  }),
  component: ResearchRunRoute,
});

function ResearchRunRoute() {
  const { sessionName } = Route.useParams();
  return <ResearchRunPage sessionName={sessionName} />;
}
